import { render, staticRenderFns } from "./TemplateViewer.vue?vue&type=template&id=a2e5bb64&scoped=true&"
import script from "./TemplateViewer.vue?vue&type=script&lang=js&"
export * from "./TemplateViewer.vue?vue&type=script&lang=js&"
import style0 from "./TemplateViewer.vue?vue&type=style&index=0&id=a2e5bb64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e5bb64",
  null
  
)

export default component.exports